export const SIMULACAO_SELO = "Simulado";
